import { apiClient } from './client';
import type {
  Conversation,
  ConversationListResponse,
  Message,
  Label,
  SendMessageBody,
} from '@/types/chat.types';

export interface ListConversationsParams {
  status?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export const chatApi = {
  // El backend standalone devuelve un array plano (sin envelope {data}).
  // Se normaliza acá para no tocar los consumidores que ya esperan { data }.
  listConversations: async (params: ListConversationsParams = {}): Promise<ConversationListResponse> => {
    const { data } = await apiClient.get<Conversation[]>('/chat/conversations', { params });
    return { data };
  },

  // El backend expone GET /chat/messages?conversationId=... (NO /chat/conversations/:id/messages),
  // y devuelve los mensajes en orden DESC (más nuevo primero); se invierte para mostrar cronológico.
  getMessages: async (conversationId: string): Promise<Message[]> => {
    const { data } = await apiClient.get<Message[]>('/chat/messages', {
      params: { conversationId },
    });
    return [...data].reverse();
  },

  sendMessage: async (body: SendMessageBody): Promise<Message> => {
    // El backend espera `body` (CreateMessageSchema), no `content`
    const { data } = await apiClient.post<Message>('/chat/messages', {
      conversationId: body.conversationId,
      body: body.content,
    });
    return data;
  },

  getLabels: async (): Promise<Label[]> => {
    const { data } = await apiClient.get<Label[]>('/chat/labels');
    return data;
  },
};
